import i18next from 'i18next';
import { DeviceWithoutGatewayFormDataModel, CombinedDeviceWithoutGatewayFormValueNames } from '../models';

export const DEVICE_WITHOUT_GATEWAY_CREATE_FORM_SENSOR_GROUP_VALUE = 3;

const defaultSensorFormValue: DeviceWithoutGatewayFormDataModel = {
  key: '',
  formGroupValue: DEVICE_WITHOUT_GATEWAY_CREATE_FORM_SENSOR_GROUP_VALUE,
  uuid: '',
  id: '',
  title: '',
  label: '',
  placeholder: '',
  required: false,
  multiple: false,
  type: '',
  value: '',
  rules: [],
};

export const getInitialSensorValues = (): DeviceWithoutGatewayFormDataModel[] => {
  return [
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ACTIVE_POWER,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ACTIVE_POWER_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ACTIVE_POWER_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ACTIVE_POWER_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ACTIVE_POWER_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ACTIVE_POWER_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ACTIVE_POWER_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ACTIVE_POWER_CH3_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ALARM_FLOOD,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ALARM_FLOOD_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.ALARM_TAMPER,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_ALARM_TAMPER_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.BATTERY,
      formGroupValue: DEVICE_WITHOUT_GATEWAY_CREATE_FORM_SENSOR_GROUP_VALUE,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_BATTERY_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.COUNT_DOWN,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_COUNT_DOWN_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.COUNT_UP,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_COUNT_UP_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.CURRENT,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_CURRENT_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.CURRENT_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_CURRENT_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.CURRENT_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_CURRENT_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.CURRENT_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_CURRENT_CH3_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.EXPORT_KWH,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_EXPORT_KWH_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.EXPORT_KWH_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_EXPORT_KWH_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.EXPORT_KWH_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_EXPORT_KWH_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.EXPORT_KWH_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_EXPORT_KWH_CH3_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.IMPORT_KWH,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_IMPORT_KWH_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.IMPORT_KWH_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_IMPORT_KWH_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.IMPORT_KWH_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_IMPORT_KWH_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.IMPORT_KWH_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_IMPORT_KWH_CH3_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.PEOPLE_FLOW_IN,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_PEOPLE_FLOW_IN_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.PEOPLE_FLOW_OUT,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_PEOPLE_FLOW_OUT_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.POWER_FACTOR,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_POWER_FACTOR_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.POWER_FACTOR_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_POWER_FACTOR_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.POWER_FACTOR_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_POWER_FACTOR_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.POWER_FACTOR_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_POWER_FACTOR_CH3_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.TOTAL_KWH,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_TOTAL_KWH_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.VOLTAGE,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_VOLTAGE_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.VOLTAGE_CH1,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_VOLTAGE_CH1_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.VOLTAGE_CH2,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_VOLTAGE_CH2_TEXT'),
    },
    {
      ...defaultSensorFormValue,
      key: CombinedDeviceWithoutGatewayFormValueNames.VOLTAGE_CH3,
      title: i18next.t('_DEVICE_WITHOUT_GATEWAY_FORM_SENSOR_VOLTAGE_CH3_TEXT'),
    },
  ];
};
